// import VueDropzone from './VueDropzone'
const VueDropzone = r => require.ensure([], () => r(require('./VueDropzone.vue')), 'dropzone-components-chunk')

export default VueDropzone
